import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

import type {GetUserApiArg, GetUserApiResponse} from '../../../services/rest'
import {restApi} from '../../../services/rest'
import {getPropertyFromList} from '../../../utils/getProperty'

import type {SidebarType} from './SidebarPanel.types'
import {SIDEBAR_PINNED_PROPERTIES} from './SidebarPanel.types'

export const sidebarSettings = createSlice({
  name: 'sidebarSettings',
  initialState: {
    resizeDelta: 0,
    collapsed: {} as Record<string, boolean>,
    autoCollapseDisabled: false,
  },
  reducers: {
    setSidebarCollapsed: (state, action: PayloadAction<{id: SidebarType; collapsed: boolean}>) => {
      state.collapsed[action.payload.id] = action.payload.collapsed
    },
    setResizeDelta: (state, action: PayloadAction<number>) => {
      state.resizeDelta = action.payload
    },
    setAutoCollapseDisabled: (state, action: PayloadAction<boolean>) => {
      state.autoCollapseDisabled = action.payload
    },
    toggleCollapseSidebar: (state, action: PayloadAction<SidebarType>) => {
      const currentCollapsed = state.collapsed[action.payload]
      if (currentCollapsed == null) {
        state.collapsed[action.payload] = false
      } else {
        state.collapsed[action.payload] = !currentCollapsed
      }
    },
  },
  extraReducers: builder =>
    // collapse by default if the user has unpinned the sidebar
    builder.addMatcher(restApi.internalActions.cacheEntriesUpserted.match, (state, action) => {
      action.payload.forEach(({queryDescription, value}) => {
        const {endpointName, originalArgs} = queryDescription
        if (
          endpointName === 'getUser' &&
          (originalArgs as GetUserApiArg)?.userLocator === 'current'
        ) {
          const properties = (value as GetUserApiResponse).properties

          Object.entries(SIDEBAR_PINNED_PROPERTIES).forEach(([id, propertyName]) => {
            const isPinned = getPropertyFromList(propertyName, properties)
            if (isPinned === 'false') {
              state.collapsed[id] = true
            }
          })
        }
      })
    }),
})
